import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionLabel } from "./Reveal";

export const buildFaq = (rates) => [
  ["Apa itu BagiPulsa?", "BagiPulsa adalah jasa convert pulsa jadi uang. Pulsa lebih kamu bisa ditukar menjadi saldo eWallet atau dikirim ke rekening bank."],
  ["Operator apa saja yang diterima?", `Saat ini: ${rates.map((r) => `${r.name} (${r.rate}%)`).join(", ")}.`],
  ["Berapa lama prosesnya?", "Convert pulsa di BagiPulsa hanya membutuhkan waktu 1 hingga 10 menit saja."],
  ["Apakah ada biaya admin?", "Tidak. Pencairan uang ke semua bank atau eWallet tidak dikenakan biaya apa pun."],
  ["Bagaimana rate dihitung?", "Uang yang diterima = nominal pulsa × rate operator. Contoh: pulsa Rp100.000 dengan rate 85% menjadi Rp85.000. Rate diperbarui setiap hari."],
  ["Pulsa seperti apa yang ditolak?", "Kami tidak menerima pulsa ilegal seperti hasil penipuan, cloning SIM, judi online, atau hasil bug. Pastikan pulsa dari sumber yang jelas."],
];

export const Faq = ({ rates, items }) => {
  const list = Array.isArray(items) && items.length ? items.map((x) => [x.q, x.a]) : buildFaq(rates);
  return (
  <section id="faq" data-testid="faq-section" className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-5 py-24 md:px-10 md:py-36 lg:grid-cols-12">
    <Reveal className="lg:col-span-4">
      <SectionLabel index="06">FAQ</SectionLabel>
      <h2 className="mt-6 font-display text-4xl font-bold leading-[1] tracking-tight text-paper md:text-5xl">Yang sering <span className="text-volt">ditanya.</span></h2>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-8">
      <Accordion type="single" collapsible className="border-t border-white/10">
        {list.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg font-medium text-paper hover:no-underline md:text-xl">{q}</AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-base leading-relaxed text-zinc-300">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
  );
};
